<script>
import Layout from "../../layouts/main"
import PageHeader from "../../components/page-header"
import DatePicker from "vue2-datepicker"
import moment from "moment"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export default {
	components: { Layout, PageHeader, DatePicker },
	data() {
		return {
			comisiones:[],
			users:[],
			recibos:[],
			recibos_vigentes:[],
			recibos_usuario:{
				mediopago:{}
			},
			title:"Advanced Table",
			items:[ {text:"Tables",href:"/"},{text:"Advanced",active:true} ],
			desde:'',
			hasta:'',
			vendedor:'',
			facturas:false,
			usuarioActual:null, // Para guardar el usuario cuyas facturas mostramos
			info:{
				estado:'vigente',
				fecha:'2024-10-01',
				ncontable:'5446531',
				fechacontable:'2024-10-12',
				rut:'12345678-9',
				recibide:'dsfghjkljmhnb',
				asignacion:'sala venta',
				facturas:{},
				suma:0,
				pago:'efectivo',
				medio:{},
				mediopago:{}
			},
			contabilidad_ver:{},
			mostrar:false,
			mostrar_boton:true,
			usersAll:[],
			clientes:[],
		}
	},
	methods:{
		fecha(f){return moment(f).format('DD-MM-YYYY')},
		capitalizarPrimeraLetra(t){return t?t.charAt(0).toUpperCase()+t.slice(1):''},
		mostrarresumen(user){
			this.facturas=true
			this.usuarioActual=user // Guardamos el usuario actual
			this.recibos_usuario=this.recibos.filter(r=>{
				return r.estado=='vigente'&&r.asignacion==user.name&&r.fechaComprobante>=this.desde&&r.fechaComprobante<=this.hasta
			})
			this.$nextTick(() => {
				window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
			});
		},
		mostrarRecibo(item){
			this.info=item;
			this.$refs['modal-ver'].show()
		},
		TotalesUsuarios(){
			this.users=this.users.map(user=>{
				const userRecibos=this.recibos_vigentes.filter(r=>r.asignacion===user.name && r.fechaComprobante>=this.desde && r.fechaComprobante<=this.hasta)
				const totalVentas=userRecibos.reduce((sum,r)=>sum+parseInt(r.pago_sin_exedente||0),0)
				const NRecibos=userRecibos.length
				const comisionCalculada=user.comision?totalVentas/(1.19)*(parseInt(user.comision)/100):0
				return {...user,NRecibos,totalVentas,comisionCalculada}
			})
			this.nventas=this.recibos_vigentes.filter(r=>r.fechaComprobante>=this.desde&&r.fechaComprobante<=this.hasta).length
			let total=0
			this.recibos_vigentes.forEach(e=>{
				if(e.fechaComprobante>=this.desde&&e.fechaComprobante<=this.hasta)total+=parseInt(e.pago_sin_exedente)
			})
			this.totalventas=total
		},
		formatNumber(num) {
			num=parseInt(num,10)
			if(isNaN(num))return 0
			if(num==0)return '$0'
			return num?num.toLocaleString("es-CL",{style:"currency",currency:"CLP"}):null
		},
		exportarCSV(){
			if(!this.usuarioActual) return
			const userName = this.usuarioActual.name || 'vendedor'
			const fechaDesde = moment(this.desde).format('DD-MM-YYYY')
			const fechaHasta = moment(this.hasta).format('DD-MM-YYYY')

			let csvContent = "data:text/csv;charset=utf-8,"
				+ `Nombre Vendedor:;${userName}\n`
				+ `Desde:;${fechaDesde}\n`
				+ `Hasta:;${fechaHasta}\n\n` 
				+ ["CI","Rut","Razon Social","Total","Total Neto","Tipo Pago","N Contable"].join(";") + "\n"

			this.recibos_usuario.forEach(recibo => {
				const ci=recibo.id
				const rut=recibo.rut
				const razon=recibo.recibide
				const total=this.formatNumber(recibo.pago_sin_exedente)
				const totalNeto=this.formatNumber(recibo.pago_sin_exedente /1.19)
				const tipoPago=recibo.pago.join(', ')
				const ncontable=recibo.ncontable
				csvContent += [ci,rut,razon,total,totalNeto,tipoPago,ncontable].join(";")+"\n"
			})

			const encodedUri = encodeURI(csvContent)
			const link = document.createElement("a")
			const fileName = `Recibos ${userName} ${fechaDesde} a ${fechaHasta}.csv` 
			link.setAttribute("href", encodedUri)
			link.setAttribute("download", fileName)
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		},
		generarPDF(info) {
			const modalContent = this.$refs.ReciboContentPDF; // Captura el contenido del modal
			// Aplicar clase para ocultar elementos
			modalContent.classList.add('hide-elements');
			html2canvas(modalContent, { scale: 2 }).then(canvas => {
			const imgData = canvas.toDataURL('image/png');
			const pdf = new jsPDF('p', 'mm', 'a4');
			const imgWidth = 210; // Ancho A4 en mm
			const imgHeight = (canvas.height * imgWidth) / canvas.width;
			pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
			pdf.save('Recibo_'+info.id+'.pdf');
			// Restaurar elementos visibles
			modalContent.classList.remove('hide-elements');
			});

		},
		handleAceptar(recibo){
			this.$refs['modal-ver'].hide()
		},
		fecha_mes_actual(val){
            const fechaActual = new Date(); // Obtiene la fecha actual
            const primerDiaMes = new Date(fechaActual.getFullYear(), fechaActual.getMonth(),val); // Configura el día como 1
            return moment(primerDiaMes).format('YYYY-MM-DD');
        },
		obtenerUltimoDiaDelMes(año, mes) {
			return new Date(año, mes + 1, 0).getDate();
		}
	},
	mounted(){
		const fechaActual = new Date();
		this.desde = this.fecha_mes_actual(1);
		let ultimo_dia = this.obtenerUltimoDiaDelMes(fechaActual.getFullYear(), fechaActual.getMonth())
        this.hasta = this.fecha_mes_actual(ultimo_dia);
	},
	created(){
		axios.get('/api/get_clientes').then(res=>{
			this.clientes=res.data.clientes;
			this.lote=res.data.lote;
			this.isLoading=false;
			this.usersAll=res.data.usersAll;
			console.log(this.usersAll)
		});
		axios.get('/api/get_recibos').then(res=>{
			this.users=res.data.users
			this.recibos=res.data.recibos
			if(this.user.rol=='Admin' || this.user.id==6){
				this.recibos_vigentes=this.recibos.filter(r=>r.estado=='vigente')
			}else if(this.user.rol=='Vendedor'){
				this.users=res.data.users.filter(u=>u.id==this.user.id)
				this.recibos=this.recibos.filter(r=>r.estado=='vigente'&&(r.vendedor==this.user.name))
				this.recibos_vigentes=this.recibos.filter(r=>r.estado=='vigente'&&r.vendedor==this.user.name)
			}
			this.TotalesUsuarios()
		})
	}
}
</script>
<style>
.table th {
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}
</style>
<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<h4 class="card-title">Comisiones</h4>
				<div class="row">
					<div class="col-md-12">
						<div class="card bg-primary">
							<div class="card-body">
								<div class="row mt-4">
									<div class="col-md-5 pt-1">
										<b-form-group class="text-white" label-cols-sm="2" label-cols-lg="3" label="Desde :" label-for="text">
											<date-picker v-model="desde" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
										</b-form-group>
									</div>
									<div class="col-md-5 pt-1">
										<b-form-group class="text-white" label-cols-sm="2" label-cols-lg="3" label="Hasta :" label-for="text">
											<date-picker v-model="hasta" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es"></date-picker>
										</b-form-group>
									</div>
									<div class="col-md-2">
										<b-button variant="light" block @click="TotalesUsuarios()">Ver</b-button>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="offset-md-3 col-md-6">
						<div class="card">
							<div class="card-body">
								<div class="table-responsive">
									<table class="table table-hover mb-0">
										<thead>
											<tr>
												<th>Vendedor</th>
												<th>N Recibos</th>
												<th class="ocultar">Total</th>
												<th class="ocultar">Total Neto</th>
												<th>Comisión</th>
												<th></th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(user, index) in users.filter(user=> user.comision!=null)" :key="index">
												<th scope="row">{{ user.name }}</th>
												<td>{{user.NRecibos}}</td>
												<td class="ocultar">{{formatNumber(user.totalVentas)}}</td>
												<td class="ocultar">{{formatNumber(user.totalVentas /1.19)}}</td>
												<td>{{formatNumber(Math.round(user.comisionCalculada))}}</td>
												<td><b-button variant="primary" size="sm" @click="mostrarresumen(user)">Detalles</b-button></td>
											</tr>
										</tbody>
									</table>
								</div>
							</div> 
						</div>
					</div>
					<div class="col-md-12" v-if="facturas">
						<div class="card">
							<div class="card-body">
								<div><b-button variant="primary" class="float-right" @click="exportarCSV">Exportar</b-button></div>
								<div class="table-responsive">
									<table class="table table-hover mb-0">
										<thead>
											<tr>
												<th>CI</th>
												<th>Rut</th>
												<th class="ocultar">Razón social</th>
												<th class="ocultar">Total</th>
												<th class="ocultar">Total Neto</th>
												<th class="ocultar">Tipo Pago</th>
												<th>NContable</th>
												<th>Acciones</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(recibo, index) in recibos_usuario" :key="index">
												<th>{{ recibo.id }}</th>
												<th scope="row">{{ recibo.rut }}</th>
												<td class="ocultar">{{ recibo.recibide }}</td>
												<td class="ocultar">{{ formatNumber(recibo.pago_sin_exedente) }}</td>
												<td class="ocultar">{{ formatNumber(recibo.pago_sin_exedente/1.19) }}</td>
												<td class="ocultar">{{ recibo.pago.join(', ') }}</td>
												<td>{{ recibo.ncontable }}</td>
												<td>
													<b-button variant="primary" size="sm" @click="mostrarRecibo(recibo)"><i class="bx bx-show"></i></b-button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
								<b-modal ref="modal-ver" no-close-on-backdrop title="Ver Recibo Digital" size="lg">
									<div class="row" ref="ReciboContentPDF">
										<div class="col-md-12 p-5">
											<div class="col-md-12 mt-3 mb-3">
												<div class="row" style="display: flex; justify-content: space-between; align-items: center;">
													<!-- Texto alineado a la izquierda -->
													<div class="col-md-7" style="text-align: left; padding-left: 0; padding-right: 0;">
														<img src="/archivos_base/logo.png" style="height: 50px; object-fit: contain;">
														<p class="text-primary mt-2">
															<strong>Teléfono:</strong> 63 2 219881 - 63 2 204385<br>
															<strong>Dirección:</strong> Errázuriz 2066, Valdivia<br>
															<strong>Email: </strong>contacto@vamproden.cl<br>
															<strong>Dirección Web: </strong>www.vamproden.cl
														</p>
													</div>
													<!-- Imagen alineada a la derecha -->
													<div class="col-md-5 no-pdf" style="text-align: left; padding-left: 0; padding-right: 0;">
														<p class="text-primary"><b>CI:</b> {{ info.id }}</p>
														<p class="text-primary">
															<b>Nº Contable:</b>
															{{ info.ncontable }}
															<!-- <b-button class="text-danger" size="sm" variant="link" @click="agregar_input" v-if="(info.ncontable==null || mostrar_boton) && (user.rol=='Admin' || user.id==6) " :disabled="info.facturas?.some(factura => !factura.revisado)">Agregar aqui</b-button> -->
														</p>
														<!-- <b-form-input type="text" size="sm" v-model="contabilidad_ver.ncontable" :disabled="contabilidad.booln" v-if="mostrar"></b-form-input> -->
														<p class="text-primary">
															<b>Fecha Contable:</b> 
															{{ info.fechacontable?fecha(info.fechacontable):'' }}
														</p>
														<!-- <b-form-input type="date" size="sm" v-model="contabilidad_ver.fechacontable" :disabled="contabilidad.boolfecha" v-if="mostrar"></b-form-input> -->
														<!-- <b-button class="float-right" size="sm" variant="primary" @click="vali_contabilidad" v-if="mostrar">Contabilizar</b-button> -->
													</div>
												</div>
											</div>
											<div class="col-md-12 mt-3 mb-2">
												<div class="row" style="display: flex; flex-direction: column; align-items: flex-start;">
													<h3 class="text-primary" style="margin-top: 10px;">COMPROBANTE DE INGRESOS</h3>
												</div>
											</div>

											<div class="col-md-12 mb-2" style="text-align: left; padding-left: 0; padding-right: 0;">
												<div class="row border p-3 mb-3" style="background-color: #f8f9fa; display: flex; flex-direction: row; justify-content: flex-start; align-items: flex-start; margin-left: 0; margin-right: 0;">
													<!-- Primera columna -->
													<div class="col-md-6" style="text-align: left; padding-left: 0; padding-right: 0;">
														<p class="text-primary"><b>Fecha Pago:</b> {{ fecha(info.fecha) }}<br>
															<b>Fecha Comprobante:</b> {{ fecha(info.created_at) }}<br>
															<b>Recibí de:</b> {{ capitalizarPrimeraLetra(info.recibide) }}<br>
															<b>Rut:</b> {{ info.rut }}
														</p>
													</div>
													<!-- Segunda columna -->
													<div class="col-md-6" style="text-align: left; padding-left: 0; padding-right: 0;">
														<p class="text-primary"><b>Generado por:</b> {{ usersAll.find(u=>u.id==info.creado_user_id)?.name || '' }}<br>
															<b>Estado:</b> {{ capitalizarPrimeraLetra(info.estado) }}<br>
															<b>Asignación:</b> {{ capitalizarPrimeraLetra(info.asignacion) }}
														</p>
													</div>
												</div>
											</div>

											<div class="col-md-12 mb-2">
												<div class="row text-left">
													<div class="col-md-12" style="text-align: left; padding-left: 0; padding-right: 0;">
														<p style="color: #21308F;"><b>Por Concepto de: </b></p>

														<div class="table-responsive">
															<table class="table table-hover mb-0" style="border: 1px solid #21308F; border-collapse: collapse;">
																<thead>
																	<tr style="background-color: #f8f9fa;">
																		<th class="no-pdf" v-if="user.rol=='Admin' || user.id==6" style="border: 1px solid #21308F;">Check</th>
																		<th style="border: 1px solid #21308F;">Nº Factura</th>
																		<th style="border: 1px solid #21308F;">Monto</th>
																		<th style="border: 1px solid #21308F;">Pago</th>
																		<th style="border: 1px solid #21308F;">Vencimiento</th>
																		<th class="no-pdf" style="border: 1px solid #21308F;">Estado</th>
																	</tr>
																</thead>
																<tbody>
																	<tr v-for="(factura, index) in info.facturas" :key="index" :class="factura.revisado ? 'table-success' : ''">
																		<td v-if="user.rol=='Admin' || user.id==6" class="no-pdf" style="border: 1px solid #21308F;">
																			<b-form-checkbox v-model="factura.revisado" :disabled="info.ncontable!='' || info.ncontable!=null ? true:false"></b-form-checkbox>
																		</td>
																		<td scope="row" style="border: 1px solid #21308F;">{{ factura.concepto }}</td>
																		<td style="border: 1px solid #21308F;">{{ factura.valor }}</td>
																		<td style="border: 1px solid #21308F;">{{ formatNumber(factura.pago) }}</td>
																		<td style="border: 1px solid #21308F;">{{ factura.fecha }}</td>
																		<td class="no-pdf" style="border: 1px solid #21308F;"><strong class="text-danger">{{ factura.cli_estado }}</strong></td>
																	</tr>
																</tbody>
															</table>
														</div>
													</div>
												</div>
											</div>
											<div class="col-md-12 mt-4 mb-4" v-if="info.pago && info.pago.length>0">
												<div class="row" style="display: flex; justify-content: space-between; align-items: center;">
													<!-- Texto alineado a la izquierda -->
													<div class="col-md-6" style="text-align: left; padding-left: 0; padding-right: 0;">
														<p class="text-primary mt-2"><b>Medio de pago utilizado:</b></p>

														<!-- Pago en efectivo -->
														<p class="text-primary col-12" v-if="info.pago.includes('efectivo')">
															<b><u>Efectivo:</u></b> {{ info.mediopago.montoefectivo }}
														</p>

														<!-- Pago con cheque -->
														<p class="text-primary col-12" v-if="info.pago.includes('cheque')">
															<b><u>Cheque:</u></b>
														</p>
														<div class="row">
															<p class="text-primary col-4" v-if="info.pago.includes('cheque')">
																<b>Nº:</b> {{ info.mediopago.cheque.n }}
															</p>
															<p class="text-primary col-4" v-if="info.pago.includes('cheque')">
																<b>Banco:</b> {{ capitalizarPrimeraLetra(info.mediopago.cheque.banco) }}
															</p>
															<p class="text-primary col-4" v-if="info.pago.includes('cheque')">
																<b>Fecha:</b> {{ fecha(info.mediopago.cheque.fecha) }}
															</p>
														</div>

														<!-- Pago con tarjeta -->
														<p class="text-primary col-12" v-if="info.pago.includes('tarjeta')">
															<b><u>Tarjeta: </u></b>{{ info.mediopago.montotarjeta }} / {{ info.mediopago.montotransferencia }}
														</p>
														<p class="text-primary col-12" v-if="info.pago.includes('tarjeta')">
															{{ capitalizarPrimeraLetra(info.mediopago.tipotarjeta) }}
														</p>

														<!-- Pago con Webpay -->
														<p class="text-primary col-12" v-if="info.pago.includes('webpay')">
															<b><u>Webpay:</u></b> {{ info.mediopago.montowebpay }}
														</p>
														<p class="text-primary col-12" v-if="info.pago.includes('webpay')">
															{{ capitalizarPrimeraLetra(info.mediopago.tipowebpay) }}
														</p>

														<!-- Pago por transferencia -->
														<p class="text-primary col-12" v-if="info.pago.includes('transferencia')">
															<b><u>Transferencia:</u></b> {{ info.mediopago.montotransferencia }}
														</p>

														<!-- Pago excedente -->
														<p class="text-primary col-12" v-if="info.pago.includes('excedente')">
															<b><u>Excedente:</u></b> {{ info.mediopago.montoexcedente }}
														</p>
													</div>

													<!-- Imagen alineada a la derecha -->
													<div class="col-md-6" style="text-align: left; padding-left: 0; padding-right: 0;">
														<div class="border p-3 mb-3" style="background-color: #f8f9fa;">
															<p class="text-primary mb-1"><b>Total facturas:</b> <span class="font-weight-bold">{{ formatNumber(info.suma) }}</span></p>
															<p class="text-primary mb-1"><b>Total abonado:</b> <span class="font-weight-bold">{{ formatNumber(info.pago_sin_exedente) }}</span></p>
															<p class="text-primary mb-1"><b>Total recibo (Incluye excedentes):</b> <span class="font-weight-bold">{{ formatNumber(info.aPagar) }}</span></p>
															<p class="text-primary mb-1"><b>Excedente a favor acumulado:</b> <span class="font-weight-bold">{{ formatNumber(info.aFavor) }}</span></p>
														</div>
													</div>

												</div>
											</div>
										</div>
									</div>
									<template #modal-footer>
										<div class="w-100" >
										<!-- comentado descargar pdf -->
											<b-button v-if="true" class="float-left mr-1" variant="primary" @click="generarPDF(info)">
												<i class="bx bxs-file-pdf font-size-16 mr-1"></i> Descargar PDF
											</b-button>
											<b-button class="float-right" variant="primary" @click="handleAceptar(info)">
												Aceptar
											</b-button>
										</div>
									</template>
								</b-modal>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
<style>
@media (max-width: 992px) {
    .ocultar {
        display: none;
    }
}
@media (min-width: 992px) {
    .ocultar-lg {
        display: none;
    }
}
</style>
